'use client';

import { Children, type ReactNode, useId, useState } from 'react';

import styles from './article-blocks.module.css';

export function PostsPagination({ children, gridClassName, locale }: { children: ReactNode; gridClassName: string; locale: string }) {
  const [page, setPage] = useState(0);
  const id = useId();
  const cards = Children.toArray(children);
  const totalPages = Math.ceil(cards.length / 6);
  const currentPage = Math.min(page, Math.max(0, totalPages - 1));
  const isArabic = locale.startsWith('ar');

  return (
    <>
      <div id={id} className={gridClassName}>
        {cards.slice(currentPage * 6, (currentPage + 1) * 6)}
      </div>
      {totalPages > 1 ? (
        <nav className={styles.pagination} aria-label={isArabic ? 'صفحات المقالات' : 'Articles pagination'}>
          <button type="button" aria-controls={id} disabled={currentPage === 0} onClick={() => setPage(currentPage - 1)}>
            {isArabic ? '« السابق' : '« Previous'}
          </button>
          <span className="sr-only" role="status">
            {isArabic ? `الصفحة ${currentPage + 1} من ${totalPages}` : `Page ${currentPage + 1} of ${totalPages}`}
          </span>
          <button type="button" aria-controls={id} disabled={currentPage === totalPages - 1} onClick={() => setPage(currentPage + 1)}>
            {isArabic ? 'التالي »' : 'Next »'}
          </button>
        </nav>
      ) : null}
    </>
  );
}
